import React, { FC, ReactNode } from 'react';
import { LobCode } from '../LobIcon/LobCode';
import Content from './Content';
import { StyledButton } from './ProductWidget.styles';

export interface ProductWidgetProps {
  lobCode: LobCode;
  productTypeTitle: string;
  productTypePath: string;
  isClickable: boolean;
  children: ReactNode;
}

const ProductWidget: FC<ProductWidgetProps> = ({ children, lobCode, productTypeTitle, productTypePath, isClickable }) => {
  const handleClick = isClickable ? () => { window.location.href = productTypePath; } : undefined;
  return (
    <StyledButton
      data-testid={lobCode}
      clickable={isClickable}
      onClick={handleClick}
      aria-label={productTypeTitle}
      disabled={!isClickable}
    >
      <Content lobCode={lobCode} productTypeTitle={productTypeTitle}>
        {children}
      </Content>
    </StyledButton>
  );
};

export default ProductWidget;
